import styled from "styled-components";

const Container = styled.div`
  border-radius: 0px 0px 0px 24px;
  position: relative;
  width: 100%;
  height: 400px;
  @media (min-width: 768px) {
    height: 550px;
  }
`;
const Thumbnail = styled.img`
  width: 100%;
  height: 400px;
  object-fit: cover;
  border-radius: 0px 0px 0px 24px;
  @media (min-width: 768px) {
    height: 550px;
  }
`;

const Content = styled.div`
  background: rgba(94, 81, 77, 0.25);
  border-radius: 0px 0px 0px 24px;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
`;

const Logo = styled.img`
  width: 212px;
  height: 32px;
  object-fit: cover;
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 24px;
  line-height: 30px;
  color: rgb(255, 255, 255);
  margin-bottom: 12px;
`;

const Subtitle = styled.div`
  font-size: 14px;
  color: rgb(255, 255, 255);
`;

const ThumbnailBig = ({ title, desc, img }) => {
  return (
    <Container className="position-relative overflow-hidden">
      <div className="mb-lg-0 mx-0 d-flex align-items-center position-relative">
        <Thumbnail src={img} />
        <Content className="p-3 d-flex flex-column justify-content-end">
          <div className="p-0 order-lg-1 mb-lg-0 mx-0 px-lg-3 mx-lg-3">
            <Title className="p-2 ps-lg-5">{title}</Title>
            <Subtitle
              className="p-2 ps-lg-5"
              dangerouslySetInnerHTML={{ __html: desc }}
            ></Subtitle>
          </div>
        </Content>
      </div>
    </Container>
  );
};

export default ThumbnailBig;
